import { useState, useEffect } from 'react';

const envs = ['lawyers', 'starter', 'basico', 'lite', 'pro', 'enterprise', 'pyme', 'team', 'demo', 'enterprise-test', 'enterprise-stage', 'freemium', 'clm-test']

export function useDomainProperties() {

    const [domain, setDomain] = useState({});
    const hostname = String(window.location.hostname).toLowerCase().split('.')[0];

    useEffect(() => {
        if (!envs.includes(hostname) && !hostname.includes('localhost') && !hostname.includes('127.'))
            setDomain({
                logo: `https://trato-images.s3.amazonaws.com/logos/${hostname}.svg`,
                hostname
            })
    }, [hostname])

    return { domain }

}
